import type { IntlShape } from 'react-intl';
import type { PeopleDay } from '../outreachTypes';
import { peopleMessages as messages } from './peopleMessages';

/** `YYYY-MM-DD` of a date in the viewer's zone. */
export function localDayKey(date: Date): string {
  return date.toLocaleDateString('en-CA');
}

/**
 * The day line of the People list (design outreach-v2 g1): "Today", "Yesterday" or "Fri, Oct 28",
 * with "release day" on the release day. `day` is `YYYY-MM-DD` of the artist's zone.
 */
export function peopleDayLabel(
  intl: IntlShape,
  day: string,
  releaseDay: string | null,
  now: Date = new Date()
): string {
  const yesterday = new Date(now.getTime() - 24 * 60 * 60 * 1000);
  const name =
    day === localDayKey(now)
      ? intl.formatMessage(messages.dayToday)
      : day === localDayKey(yesterday)
        ? intl.formatMessage(messages.dayYesterday)
        : intl.formatDate(new Date(`${day}T12:00:00Z`), {
            weekday: 'short',
            month: 'short',
            day: 'numeric',
            timeZone: 'UTC',
          });
  return releaseDay === day ? intl.formatMessage(messages.dayRelease, { day: name }) : name;
}

/** "3 sent · 2 waiting", "5 sent" or "2 waiting". */
export function peopleDayCounts(intl: IntlShape, day: PeopleDay): string {
  if (day.waiting === 0) {
    return intl.formatMessage(messages.daySent, { sent: day.sent });
  }
  if (day.sent === 0) {
    return intl.formatMessage(messages.dayWaiting, { waiting: day.waiting });
  }
  return intl.formatMessage(messages.dayCounts, { sent: day.sent, waiting: day.waiting });
}
